import {getJson, postJson} from '@/util/ajaxUtils';

export function addReportLine(userId, subUserIds, groupUserIds) {
    const data = {
        subUserIds,
        groupUserIds,
    };
    return postJson(`/reportLine/${userId}/users`, {data});
}

export function addReportDepartsLine(userId, subUserIds, departIds) {
    const data = {
        subUserIds,
        departIds,
    };
    return postJson(`/reportLine/${userId}/users/departs`, {data});
}

export function getReportLine(userId) {
    return getJson(`/reportLine/${userId}`);
}

export function getReportUsers(userId) {
    return getJson(`/reportLine/list/${userId}`);
}
